import { Button, H2 } from "@sellar-io/components";
import { SpinnerLegacy } from "../../../../../../../../components";
import { useFullPageDialogContext } from "../../../../../../../../components/modal/useFullPageDialogContext";
import { useSellarUser } from "../../../../../../../../hooks";
import { useSellarCurrentBusiness } from "../../../../../../../../hooks/useSellarCurrentBusiness.shared";
import { formatCurrency } from "@sellar-io/common";
import { SellarCreditTwoDialogPageEnum } from "../types/SellarCreditTwoDialogPageEnum";
import { useLegalEntityCompanyCreditInfo } from "../../../../../../../../hooks/api/v2/legalEntity/useLegalEntityCompanyCreditInfo";
import { SellarCreditTwoDialogPage } from "./SellarCreditTwoDialogPage";

export const SellarCreditCheckCreditLimit = () => {
  const { setPage } = useFullPageDialogContext();
  const { business } = useSellarCurrentBusiness();
  const { user } = useSellarUser();

  const companyCreditInfoQuery = useLegalEntityCompanyCreditInfo(
    {
      RetailerId: business?.Retailer?.id ?? 0,
    },
    {
      enabled: Boolean(business?.Retailer?.id) && Boolean(user?.id),
    },
  );

  const { data } = companyCreditInfoQuery;

  const credit = data?.creditLimitQuote;

  if (!credit) {
    return <SpinnerLegacy />;
  }

  return (
    <SellarCreditTwoDialogPage
      className="mt-8"
      contentClassName="justify-center gap-4"
    >
      <div className="mb-4">
        <SellarCreditStatus balance={credit} />{" "}
      </div>

      <H2>
        Congrats! You're eligible for {formatCurrency(credit)} credit to spend
        on Sellar
      </H2>
      <p>
        You can claim your Sellar Credit account today by completing sign up
      </p>
      <div className="mt-6 flex w-full flex-col gap-2">
        <Button
          className="w-full"
          onClick={() =>
            setPage(
              SellarCreditTwoDialogPageEnum.TWO_ACCOUNT_VERIFICATION_INTRO,
            )
          }
        >
          Claim your credit
        </Button>
      </div>
    </SellarCreditTwoDialogPage>
  );
};

const SellarCreditStatus = ({ balance }: { balance: number }) => {
  const formattedBalance = formatCurrency(balance);

  return (
    <div className="relative flex">
      <div className="relative w-full max-w-[400px]">
        <div className="flex h-[50px] cursor-pointer items-center rounded-lg border border-zinc-800 bg-white shadow-md">
          <div className="flex h-full items-center">
            <div className="flex shrink-0 gap-1 px-2">
              <div>
                <img
                  src="https://sellar.imgix.net/sellar-image-assets/app-assets/sellar-icon-gradient.svg"
                  className="w-[18px]"
                />
              </div>

              <img src="https://sellar.imgix.net/sellar-image-assets/app-assets/sellar-credit-balance-gradient.svg" />
            </div>
          </div>

          <div className="flex h-full items-center justify-center gap-1 rounded-r-lg bg-gradient-to-br from-[#B557F1] to-[#D213A6] px-2 text-xs font-semibold text-nowrap text-white sm:px-4 sm:text-sm">
            {formattedBalance}
          </div>
        </div>

        {/* sparkle top */}
        <div className="absolute top-[-60px] left-[-50px] z-50">
          <img
            src="https://sellar.imgix.net/sellar-image-assets/app-assets/sparkle-top.png"
            className="w-[70px]"
          />
        </div>

        {/* sparkle bottom */}

        <div className="absolute right-[-40px] bottom-[-30px] z-50">
          <img
            src="https://sellar.imgix.net/sellar-image-assets/app-assets/sparkle-bottom.png"
            className="w-[35px]"
          />
        </div>
      </div>
    </div>
  );
};
